import { render, staticRenderFns } from "./InventoryTransferPermissionDialog.vue?vue&type=template&id=216d2229&scoped=true"
import script from "./InventoryTransferPermissionDialog.vue?vue&type=script&lang=ts"
export * from "./InventoryTransferPermissionDialog.vue?vue&type=script&lang=ts"
import style0 from "./InventoryTransferPermissionDialog.vue?vue&type=style&index=0&id=216d2229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d2229",
  null
  
)

export default component.exports